import Auth from './Auth/Auth';
import ChangePassword from './Changepassword/Changepassword';

const ContextProvider = ({ children }: { children: JSX.Element }) => {
  return (
    <Auth>
      <ChangePassword>{children}</ChangePassword>
    </Auth>
  );
};

export default ContextProvider;
